// i18n area 'vms' — locale es-ES (task #171, onda 1): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/vms.es-ES.meta.json.
import type { enUS } from './vms'

export const esES: typeof enUS = {
  vms: {
    spof: {
      title: 'Independencia del nodo',
      single: 'Punto único de fallo',
      alternativesNow: 'Alternativas ahora',
      structural: 'Por construcción',
      binding: 'Restricción vinculante',
      movableNow: 'Migrable ahora',
    },
    title: 'Máquinas virtuales',
    migratingChip: 'Migración en curso',
    templateChip: 'Template',
    expendableTooltip: 'En un clúster degradado está entre las primeras en caer y podría no reiniciarse tras la pérdida de un nodo.',
    expendableHaTooltip: 'Siempre reiniciada mientras el clúster está sano; en un clúster degradado las VM protegidas van primero — puede detenerse o quedar apagada hasta que el clúster vuelva a estar completo, luego vuelve sola.',
    viewDetails: 'Ver detalles',
    profileLegacy: 'Otro OS',
    hugePagesNone: 'Ninguna — memoria normal',
    hugePages2M: 'Páginas de 2 MiB',
    hugePages1G: 'Páginas de 1 GiB',
    searchPlaceholder: 'Buscar por nombre',
    name: 'Nombre',
    vcpus: 'vCPU',
    memory: 'Memoria',
    ipAddresses: 'Direcciones IP',
    noIp: 'Sin IP',
    authorityNode: 'Authority',
    authorityNextStart: 'asignada en el próximo arranque',
    scope: 'Scope',
    empty: 'Ninguna máquina virtual',
    loadError: 'No se pudieron cargar las máquinas virtuales — ¿el backend TVirt es alcanzable?',
    filterOverlay: 'red overlay',
    filterDisk: 'disco',
    filterImage: 'imagen',
    filteredBy: 'Filtradas por {kind}',
    filterPhase: 'Fase',
    filterProtection: 'Protección',
    filterAll: 'Todas',
    filterScopePlaceholder: 'Filtrar por scope',
    filtersToggle: 'Filtros',
    scopeTree: {
      title: 'Scopes',
      all: 'Todo el clúster',
      noChildren: 'Ningún sub-scope aquí',
      recursive: 'Incluir descendientes',
      collapse: 'Contraer el panel de scopes',
      up: 'Subir un nivel',
      countTooltip: '{direct} VM en este scope · {total} con los descendientes'
    },
    isoPicker: {
      catalog: 'Catálogo',
      unknownCatalog: 'Fuera de los catálogos visibles',
      noIsos: 'Ninguna imagen ISO lista en este catálogo'
    },
    actionsHeader: 'Acciones',
    templatesTab: {
      quickDeploy: 'QuickDeploy',
      hardware: 'Hardware',
      tags: 'Tags',
      age: 'Antigüedad',
      disk: 'disco',
      disks: 'discos',
      empty: 'Ningún template — marque como template una VM apagada, o clone una VM como template.',
      clone: 'Clonar / deploy',
      editTags: 'Editar tags',
      exportAction: 'Exportar al catálogo (.tvtpl)',
      exportTitle: 'Exportar al catálogo',
      exportSubmit: 'Exportar',
      exportError: 'Exportación fallida',
      exportHint: 'El template se empaqueta en un archivo .tvtpl (manifest de hardware + cada disco aplanado a qcow2) como nuevo archivo Template VM en el catálogo elegido. NIC, medios CD/DVD y cloud-init no viajan — la spec del formato lista cada omisión deliberada.',
      exportName: 'Nombre del archivo',
      exportNameHint: 'Vacío = <template>-export-<n>',
      exportStorageDefault: 'El storage de metadatos del template',
      importAction: 'Importar desde catálogo',
      importTitle: 'Importar desde catálogo',
      importHint: 'Un archivo Template VM ready del catálogo elegido se convierte en un template del inventario: el formato del archivo (tvtpl, ova, ovf o qcow2 desnudo) decide solo cómo se importa — usted elige únicamente el archivo.',
      importFile: 'Archivo de catálogo',
      importFileHint: 'Solo se importan archivos ready — uno a medio upload no es importable',
      importNoFiles: 'Ningún archivo Template VM ready en este catálogo — primero suba o exporte uno'
    },
    templateDetail: {
      quickDeploy: 'Compatibilidad QuickDeploy',
      quickDeployNone: 'No declarada',
      quickDeployHint: 'Decláralo solo si la imagen golden contiene cloud-init (Linux) o cloudbase-init tras sysprep /generalize (Windows): la plataforma confía en la declaración y nunca mira dentro del guest.',
      notFound: 'Template no encontrado',
      frozen: 'La configuración hardware está congelada: reconvierta el template en VM para modificarla. Nombre, notas y tags siguen siendo editables.',
      storage: 'Storage',
      size: 'Tamaño',
      configTitle: 'Configuración (congelada)',
      usbClasses: 'Clases USB requeridas',
      gpuClasses: 'Clases GPU requeridas'
    },
    sharedDisksTab: {
      title: 'Discos compartidos',
      sharing: 'Compartición',
      sharingNone: 'Un solo attach',
      sharingMultiwriter: 'Escritura compartida (multiwriter)',
      sharingReadonly: 'Solo lectura compartida',
      usedBy: 'En uso por',
      attachedTo: 'Conectado a',
      notAttached: 'Conectado a ninguna VM',
      changeSharing: 'Cambiar modo de compartición',
      changeSharingTitle: 'Modo de compartición',
      changeSharingLocked: 'El modo solo cambia mientras ninguna VM usa el disco',
      sharingChanged: 'Modo de compartición actualizado.',
      lun: 'LUN entera',
      lunNumber: 'LUN / namespace',
      lunWwn: 'WWN',
      lunSerial: 'Serie',
      antiAffinityWarning: 'Dos o más miembros corren en el mismo nodo sin regla de antiafinidad: el fallo de un nodo los tumba a todos',
      antiAffinityCreate: 'Crear la regla',
      createSourceLun: 'Adoptar una LUN entera del target',
      createLunNumber: 'Número de LUN (id de namespace en NVMe)',
      createLunHint: 'No se asigna nada: el tamaño se observa en el dispositivo al adoptar',
      noPr: 'En esta versión no hay SCSI-3 persistent reservations: un Windows Failover Cluster con disco compartido clásico no está validado; los clústeres que coordinan por red (GFS2/OCFS2, RHEL HA, bases de datos de disco compartido) sí'
    },
    unusedDisksTab: {
      title: 'Discos sin usar',
      attach: 'Conectar a una VM',
      attachTitle: 'Conectar a una VM',
      vm: 'Máquina virtual',
      noVms: 'Ninguna VM disponible',
      noSlots: 'Ningún slot libre en esta VM',
      create: 'Crear disco',
      createTitle: 'Crear disco',
      createSourceBlank: 'Disco vacío',
      createSourceImage: 'Desde una imagen del catálogo',
      createImage: 'Imagen',
      createImageEmpty: 'No hay ninguna imagen de plantilla de VM lista en los catálogos visibles',
      createSizeFromImageHint: 'Precompletado con el tamaño virtual de la imagen — solo puede crecer',
      convert: 'Convertir en template VM…',
      convertOnlyQcow2: 'Solo se convierten discos qcow2 — raw no es un formato de template registrable',
      convertTitle: 'Convertir en template VM',
      convertSubmit: 'Convertir (destruye el disco)',
      convertError: 'No se pudo iniciar la conversión',
      convertWarning: 'DESTRUCTIVO: el disco se convierte en un archivo template VM en el catálogo elegido — mismo storage, cero bytes copiados — y DEJA DE EXISTIR como disco. No hay vuelta atrás salvo crear un disco nuevo desde el template.',
      convertNameHint: 'El nombre del archivo de catálogo — por defecto el del propio disco',
      convertConfirm: 'Entiendo: el disco será destruido',
      convertStarted: 'Conversión iniciada — el template aparece en el catálogo al término del task.',
      storageLockHint: 'El storage cambia solo con la acción Mover',
      source: 'Procedencia',
      sourceClone: 'Clon de otro disco',
      sourceCloneLinked: 'Linked clone de otro disco',
      sourceImage: 'Creado desde una imagen',
      sourceBlank: 'Creado vacío',
      allocated: 'Asignado / tamaño virtual',
      observedAt: 'Observado el',
      snapshots: 'Snapshots',
      snapshotsEmpty: 'Ningún snapshot'
    },
    phase: {
      defined: 'Nunca encendida',
      starting: 'Arrancando',
      running: 'En ejecución',
      stopping: 'En parada',
      stopped: 'Apagada',
      paused: 'En pausa',
      failed: 'En error',
      deleting: 'En eliminación'
    },
    stopCause: {
      'api': 'Detenida por TVirt (acción o API)',
      'guest-shutdown': 'Shutdown iniciado por el sistema operativo guest',
      'crash': 'Crash del guest',
      'qemu-exit': 'El proceso QEMU terminó de forma inesperada',
      'host-reboot': 'El nodo se reinició',
      'migrated': 'Migrada a otro nodo',
      'fenced': 'Terminada por el fencing HA (nodo reincorporado)'
    },
    detail: {
      notFound: 'Máquina virtual no encontrada',
      details: 'Detalles',
      id: 'ID',
      scope: 'Scope',
      profile: 'Perfil hardware',
      firmware: 'Firmware',
      firmwareFile: 'Versión de firmware UEFI',
      firmwareUpdate: 'Actualización disponible',
      firmwareUpdateHint: 'La plataforma incluye un firmware UEFI más reciente. La actualización nunca es automática: se aplica con la VM apagada, cuando tú lo decidas.',
      arch: 'Arquitectura',
      node: 'Nodo',
      bootOrder: 'Orden de boot',
      agent: 'Estado del agent',
      agentConnected: 'Conectado',
      agentNotConnected: 'No conectado',
      protected: 'Protegida',
      linkedClones: 'Clones vinculados',
      restartPolicy: 'Política de reinicio',
      preferredNode: 'Nodo preferido',
      noPreference: 'Sin preferencia (placement automático)',
      preferNodes: 'Tags de nodo preferidos',
      requireNodes: 'Tags de nodo obligatorios',
      noPlacementTags: 'Ninguno',
      placementTag: 'Tag',
      placementValue: 'Valor',
      placementAddTag: 'Añadir tag',
      proximityHa: 'HA de TVirt Proximity',
      proximityHaRestarts: 'reinicios HA',
      proximityHaGaveUp: 'crash loop — HA se rindió',
      failoverProtection: 'Protección en degradado',
      protectionProtected: 'Protegida',
      protectionExpendable: 'Sacrificable en degradado',
      protectionInherit: 'Heredar',
      lastStop: 'Último apagado',
      yes: 'Sí',
      no: 'No',
      tabOverview: 'Resumen',
      tabSnapshots: 'Snapshots',
      tabBackups: 'Copias',
      hardware: 'Hardware',
      name: 'Nombre',
      hwSystem: 'Sistema',
      hwCpu: 'CPU',
      hwMemory: 'Memoria',
      hwBoot: 'Arranque',
      hwIdentity: 'Identidad',
      hwCluster: 'Clúster y agent',
      cpuTopology: 'Topología de CPU',
      cpuModel: 'Modelo de CPU',
      cpuLimit: 'Límite de CPU',
      cpuWeight: 'Peso de CPU',
      cpuNested: "Virtualización anidada",
      cpuNestedHint: "Expone vmx/svm al invitado (solo con modelo de CPU host). En una VM encendida el cambio aplica en el próximo power cycle (PendingRestart); la colocación solo admite nodos con nested habilitado.",
      unlimited: 'Ilimitado',
      memory: 'Memoria',
      balloon: 'Balloon',
      hugePages: 'Páginas enormes',
      hugePagesTradeoff: 'Menos trabajo de traducción de direcciones y memoria que nunca va al disco; a cambio la reserva queda bloqueada en el nodo mientras la VM está encendida, la memoria ya no se deduplica y el arranque falla si el nodo no tiene suficientes páginas libres.',
      disks: 'Discos',
      cdroms: 'Unidades CD/DVD',
      nics: 'Interfaces de red',
      slot: 'Slot',
      disk: 'Disco',
      encrypted: 'Cifrado',
      image: 'Imagen',
      emptyDrive: 'Unidad vacía',
      emptyOption: '(vacío)',
      network: 'Red',
      mac: 'MAC',
      connected: 'Conectada',
      unplugged: 'Desconectada',
      noDevices: 'Ninguno',
      screenshot: 'Screenshot',
      capturedAt: 'Capturado a las',
      noCapture: 'Ninguna captura',
      snapshotName: 'Nombre',
      snapshotCreated: 'Creado',
      snapshotMemory: 'Memoria incluida',
      noSnapshots: 'Ningún snapshot',
      pendingRestart: 'Cambios pendientes: se aplicarán en el próximo power cycle.',
      applied: 'aplicado',
      appliedHint: 'La VM está corriendo con este valor — el configurado se aplica en el próximo power cycle.',
      actionError: 'Acción fallida',
      actionStillRunning: 'La acción sigue en curso: el resultado aún no se conoce',
      tabConsole: 'Consola',
      consoleConnect: 'Conectar',
      consoleDisconnect: 'Desconectar',
      consoleConnecting: 'Conectando…',
      consoleReconnecting: 'Conectando…',
      consoleUnavailable: 'La consola está disponible con la VM en ejecución o en pausa.',
      consoleError: 'Conexión a la consola fallida',
      consoleTaken: 'Sesión de consola tomada por {user}',
      consoleReconnect: 'Reconectar',
      consoleCtrlAltDel: 'Ctrl+Alt+Supr',
      consoleHold: 'Mantener pulsado {key}',
      consoleFn: 'Fn…',
      consoleFullscreen: 'Abrir a pantalla completa en un tab nuevo',
      consoleLoadFailed: 'VM no encontrada o permisos insuficientes',
      consoleClose: 'Cerrar',
      tabStats: 'Estadísticas',
      tabTasks: 'Tasks',
      tabLogs: 'Logs',
      statsCpu: 'CPU',
      statsMemory: 'Memoria',
      statsDisk: 'I/O de disco',
      statsRange: 'Intervalo',
      statsNoData: 'Sin datos en el intervalo — las estadísticas se muestrean con la VM en ejecución.',
      statsError: 'No se pudieron cargar las estadísticas',
      cpuUsage: 'Uso',
      cpuReady: 'Ready (%RDY)',
      memUsed: 'Usada',
      memGuestAvailable: 'Disponible (guest)',
      schema: 'Schema',
      consoleProtocol: 'Consola',
      agentEnabled: 'Guest agent',
      metadataStorage: 'Storage de metadatos',
      startupOnBoot: 'Arranque al boot',
      startupOrder: 'Orden de arranque',
      startupDelay: 'Retardo de arranque',
      seconds: 's',
      enabled: 'Habilitado',
      disabled: 'Deshabilitado'
    },
    actionsAvailable: 'Acciones disponibles',
    actions: {
      start: 'Arrancar',
      stop: 'Detener',
      pause: 'Pausar',
      resume: 'Reanudar',
      reset: 'Reset',
      migrate: 'Migrar',
      clone: 'Clonar',
      moveStorage: 'Mover a storage…',
      moveScope: 'Mover a scope…',
      openConsole: 'Abrir consola',
      forceStop: 'Forzar apagado',
      markTemplate: 'Marcar como template',
      unmarkTemplate: 'Reconvertir en VM',
      error: 'No se pudo ejecutar la acción'
    },
    cordon: {
      confirmTitle: 'El nodo está en mantenimiento',
      confirmHint:
        'El cordón no se puede bajar mientras el store del clúster está caído. Al confirmar declaras que lo sabes: la VM se enciende ahí igualmente, y el consentimiento queda registrado en la tarea.',
      confirm: 'Encender igualmente'
    },
    markTemplate: {
      confirmTitle: '¿Marcar {name} como template?',
      confirmBody: 'La configuración se congela y la VM ya no podrá encenderse — solo clonarse, o volver a ser VM. Nombre, notas y tags siguen siendo editables.',
      confirm: 'Marcar como template',
      moved: '{name} ahora es un template — se ha movido al tab Templates.'
    },
    unmarkTemplate: {
      confirmTitle: '¿Reconvertir {name} en VM?',
      confirmBody: 'El template vuelve a ser una VM ordinaria: editable y arrancable (el próximo arranque la coloca en un nodo).',
      confirm: 'Reconvertir en VM',
      moved: '{name} vuelve a ser una máquina virtual — se ha movido al tab Máquinas virtuales.'
    },

    // Round #123: riferimento a nodo per TAG (selettore #106) nei dialog
    // di start e migrazione — anteprima dell'insieme risolto inclusa.
    nodeByTag: {
      label: 'Por tag de nodo',
      hint: 'tag=valor, separados por comas (en AND): el decider elige entre los nodos coincidentes',
      invalid: 'Formato no válido — use tag=valor, separados por comas',
      resolved: 'Miembros coincidentes: {nodes}'
    },
    migrate: {
      title: 'Live migration',
      submit: 'Migrar',
      target: 'Nodo de destino',
      auto: 'Automático (Proximity)',
      hint: 'La VM se mueve sin power cycle. Todo storage que toca debe ser compartido; una VM en pausa migra en pausa.',
      error: 'La migración fue rechazada'
    },
    moveStorage: {
      title: 'Mover a storage',
      submit: 'Mover',
      target: 'Storage de destino',
      noTargets: 'Ningún storage acepta discos',
      hint: 'Todos los discos de la VM apagada viajan al storage elegido, uno a la vez, conservando su id — los que ya están en destino se saltan. El progreso vive en la página de tasks.',
      error: 'El movimiento de storage fue rechazado'
    },
    moveScope: {
      title: 'Mover a scope',
      submit: 'Mover',
      target: 'Scope de destino',
      hint: 'La VM cambia de scope inmediatamente — id y discos permanecen, sus discos owned la siguen, y puede quedarse encendida. Hoy vive en {scope}. Quién la ve cambia con el scope.',
      error: 'El movimiento de scope fue rechazado'
    },
    start: {
      title: 'Arrancar VM',
      submit: 'Arrancar',
      target: 'Nodo de destino',
      auto: 'Automático (recomendado)',
      recommended: 'recomendado',
      hint: 'Elija un nodo de destino o deje decidir a Proximity entre los candidatos válidos. Los nodos que no pueden alojarla están deshabilitados con el motivo.',
      error: 'No se pudo arrancar la VM'
    },
    console: {
      media: 'Unidades CD/DVD',
      mediaGuestToolsHint: 'Contiene las TVirt Guest Tools — desde aquí puede expulsarlas o quitar la unidad',
      slotOpsDeferred: 'En este perfil añadir y quitar unidades se aplica en el próximo power cycle (los cambios de medio son inmediatos).',
      mountGuestTools: 'Montar TVirt Guest Tools',
      ejectGuestTools: 'Expulsar TVirt Guest Tools',
      bootOrder: 'Orden de boot',
      bootOrderHint: 'El nuevo orden se guarda al momento y se aplica en el próximo power cycle — la sesión de consola sigue conectada.'
    },
    snapshots: {
      create: 'Crear snapshot',
      createTitle: 'Crear un snapshot',
      createSubmit: 'Crear',
      name: 'Nombre',
      nameHint: 'Letras, dígitos, punto, guion, guion bajo.',
      consistencyHint: 'La consistencia es automática: el guest agent congela los filesystems cuando responde; en caso contrario la VM se pausa un instante alrededor del snapshot.',
      memory: 'Incluir la memoria',
      memoryHint: 'Captura la RAM viva: revertir reanuda la VM en ejecución. Requiere todos los discos qcow2.',
      currentChip: 'Está aquí',
      revert: 'Revertir',
      revertTitle: '¿Revertir a {name}?',
      revertBody: 'Los discos vuelven al estado del snapshot; todo lo ocurrido después se pierde. Un snapshot solo-discos requiere la VM detenida.',
      delete: 'Eliminar',
      deleteTitle: '¿Eliminar el snapshot {name}?',
      deleteBody: 'El punto de restauración desaparece; el contenido de los discos queda intacto.',
      deleteMergeHint: 'Su delta se fusiona en {children}: cada punto de restauración posterior sigue siendo válido.',
      deleteDuplication: 'Acepto la duplicación',
      deleteDuplicationHint: 'El delta se copia en cada uno de los {count} lectores (los snapshots hijos y, si este es el actual, la cabeza activa): el espacio ocupado puede crecer en lugar de disminuir.',
      error: 'La operación sobre el snapshot fue rechazada'
    },
    clone: {
      title: 'Clonar VM',
      submit: 'Clonar',
      name: 'Nombre de la copia',
      storage: 'Storage de destino de los discos',
      sameStorage: 'El mismo que el origen',
      full: 'Copia completa',
      fullHint: 'Copia cada byte y corta el lazo con los discos de origen. El default es un linked clone: instantáneo, pero encadenado al origen (solo qcow2).',
      hint: 'El clon mantiene la configuración y el firmware del origen; las direcciones MAC y la identidad TPM son nuevas.',
      markAs: 'Tipo del clon',
      markAsInheritVm: 'Como el origen (VM)',
      markAsInheritTemplate: 'Como el origen (template)',
      markAsVm: 'Máquina virtual',
      markAsTemplate: 'Template',
      markAsHintVm: 'Elija Template para promover la copia en un solo paso.',
      markAsHintTemplate: 'Elija Máquina virtual para hacer el deploy desde este template en un solo paso.',
      error: 'La clonación fue rechazada'
    },
    bulk: {
      selected: 'seleccionadas',
      deleteTitle: {
        one: '¿Eliminar {count} VM seleccionada?',
        many: '¿Eliminar {count} VM seleccionadas?',
        other: '¿Eliminar {count} VM seleccionadas?'
      },
      deleteBody: 'Cada VM pasa las mismas guardas que el borrado individual; los rechazos se reportan por elemento.',
      done: 'aceptadas',
      refused: 'rechazadas'
    },
    delete: {
      button: 'Eliminar',
      confirmTitle: '¿Eliminar {name}?',
      confirmBody: 'La máquina virtual y los discos de su propiedad se eliminarán. La operación no es reversible.',
      keepDisks: 'Conservar los discos',
      keepDisksHint: 'Los discos creados con la VM permanecen en su storage como discos autónomos.',
      confirm: 'Eliminar',
      cancel: 'Cancelar',
      error: 'Eliminación fallida',
      blockedPhase: 'Detenga primero la VM',
      blockedProtected: 'La VM está protegida — quite primero la protección',
      blockedDeleting: 'Eliminación ya en curso'
    },
    logs: {
      title: 'Logs',
      subtitle: 'Frames de log estructurados de los tasks que tocan esta VM',
      when: 'Cuándo',
      task: 'Task',
      level: 'Nivel',
      message: 'Mensaje',
      empty: 'Aún ningún log',
      loadError: 'No se pudieron cargar los logs — ¿el backend TVirt es alcanzable?'
    },
    stop: {
      title: 'Detener máquina virtual',
      modeGraceful: 'Apagado graceful',
      modeGracefulHint: 'Se pide al sistema operativo guest que se apague de forma natural (ACPI); si ignora la petición, tras el timeout llega el apagado forzado.',
      modeForced: 'Apagado forzado',
      modeForcedHint: 'Corta la corriente de inmediato, como desenchufar el cable.',
      timeout: 'Timeout de fallback (segundos)',
      timeoutHint: 'Espera concedida al guest antes de forzar el apagado'
    },
    createFromScratch: 'Desde cero',
    createFromTemplate: 'Desde template',
    createQuickDeploy: 'TVirt QuickDeploy',
    quickDeploy: {
      title: 'TVirt QuickDeploy',
      submit: 'Ejecutar deploy',
      error: 'Deploy fallido',
      compatNote: 'QuickDeploy requiere una plantilla compatible con QuickDeploy: la plataforma personaliza el guest (red, dominio, activación) en el primer arranque.',
      template: 'Plantilla',
      noTemplates: 'Ninguna plantilla declara aún la compatibilidad QuickDeploy — decláralo desde la pestaña Plantillas (Linux con cloud-init, Windows con cloudbase-init tras sysprep)',
      osLinux: 'Linux (cloud-init)',
      osWindows: 'Windows (cloudbase-init)',
      hostname: 'Nombre de host',
      hostnameHint: 'Nombre de host o FQDN; vacío = el nombre de la VM (Windows: 15 caracteres como máximo)',
      ip: 'Dirección IP',
      ipHint: 'Host y prefijo, p. ej. 192.168.122.101/24; vacío = DHCP',
      gateway: 'Puerta de enlace',
      dns: 'Servidores DNS',
      dnsHint: 'Hasta tres, separados por comas',
      count: 'Instancias',
      countHint: 'Más de una: se llaman <nombre>-1…-N, solo DHCP',
      user: 'Usuario',
      userHint: 'Vacío = el usuario predeterminado de la imagen (Linux) o Administrator (Windows)',
      password: 'Contraseña',
      passwordHint: 'Se escribe en la user-data generada, que la plataforma declara después secreta: nadie la vuelve a leer',
      sshKeys: 'Claves públicas SSH',
      sshKeysHint: 'Una por línea (ssh-ed25519 AAAA… comentario)',
      productKey: 'Product key de Windows',
      kmsServer: 'Servidor KMS',
      kmsHint: 'Host o host:puerto — requiere un product key (una clave cliente KMS)',
      adDomain: 'Unirse al dominio Active Directory',
      adDomainHint: 'Vacío = sin unión al dominio',
      adUser: 'Cuenta de unión',
      adPassword: 'Contraseña de la cuenta de unión',
      adOu: 'OU de destino (opcional)',
      advanced: 'Avanzado: documentos en bruto',
      userData: 'user-data (en bruto)',
      userDataHint: 'Sustituye la user-data generada: usuario, contraseña, claves y campos Windows de arriba deben quedar vacíos',
      networkConfig: 'network-config (en bruto)',
      networkConfigHint: 'Sustituye la red generada: IP, puerta de enlace y DNS de arriba deben quedar vacíos',
      secret: 'Tratar la user-data en bruto como secreta',
      secretHint: 'Marcada como secreta, la API deja de devolvérsela a nadie y viaja en el Checkpoint sellada con la masterpass',
      startNow: 'Iniciar de inmediato',
      startNowHint: 'Cada instancia arranca en cuanto queda definida; el seed nace en ese arranque'
    },
    create: {
      nicAttachmentNetwork: 'Red lógica (fabric)',
      nicNetwork: 'Red lógica',
      nicNetworkHint: 'La vía RECOMENDADA (F3): la vNIC se realiza en el bridge DERIVADO del nodo que sirve — el bridge nace en el apply explícito de la fabric, y un arranque en un nodo que aún no lo lleva rechaza hablando. Cuando la última referencia de la flota se va, el bridge cae en el próximo apply.',
      button: 'Crear VM',
      title: 'Crear máquina virtual',
      dialogTitle: 'Crear máquina virtual',
      stepGeneral: 'General',
      stepGeneralHint: 'Nombre y perfil',
      stepCompute: 'CPU y RAM',
      stepComputeHint: 'Topología y dimensionamiento',
      stepDisks: 'Discos',
      stepDisksHint: 'Crear o conectar',
      stepCdroms: 'CD/DVD',
      stepCdromsHint: 'Unidades y medios',
      stepNetwork: 'Red',
      stepNetworkHint: 'NIC: trunk o bridge',
      stepSummary: 'Resumen',
      stepSummaryHint: 'Revisar y crear',
      name: 'Nombre',
      nameHint: 'Minúsculas, dígitos y guiones (DNS-1123)',
      nextButton: 'Siguiente',
      prevButton: 'Anterior',
      submitButton: 'Crear',
      creating: 'Creando…',
      sockets: 'Sockets',
      cores: 'Cores por socket',
      threads: 'Threads por core',
      totalVcpus: 'vCPU totales',
      memoryGib: 'Memoria (GiB)',
      cpuModelHint: "'host' expone la CPU del host",
      cpuLimitHint: 'Tope en cores del host — vacío = ilimitado',
      cpuNestedHint: "Expone vmx/svm al invitado para que ejecute su propio hipervisor — requiere el modelo de CPU host y un nodo con nested habilitado",
      newDisk: 'Disco nuevo',
      attachDisk: 'Conectar disco existente',
      diskStorage: 'Storage',
      diskSize: 'Tamaño (GiB)',
      diskSelect: 'Disco',
      addDisk: 'Añadir disco',
      addCdrom: 'Añadir unidad CD/DVD',
      addNic: 'Añadir interfaz de red',
      remove: 'Quitar',
      slotLimit: 'Límite de slots alcanzado',
      cdromImage: 'Imagen (unidad vacía si falta)',
      nicAttachment: 'Conexión',
      nicAttachmentTrunk: 'Trunk overlay',
      nicAttachmentBridge: 'Bridge del host',
      nicUntagged: 'Overlay untagged',
      nicUntaggedNone: 'Ninguna (solo tagged)',
      nicTrunkHint: 'Al menos un lado: una overlay untagged y/o mappings VLAN tagged — la VM solo puede correr en los hosts declarados por cada overlay referenciada',
      nicTaggedVlan: 'ID de VLAN',
      nicTaggedOverlay: 'Red overlay',
      addTagged: 'Añadir VLAN tagged',
      nicBridge: 'Nombre del bridge del host',
      nicBridgeHint: 'Bridge NM por nombre — la VM solo puede correr en los servidores cuya red host declara este bridge',
      nicMac: 'MAC (auto si vacío)',
      noDisksHint: 'Ningún disco: la VM tendrá solo las unidades CD/DVD que añada.',
      noCdromsHint: 'Ninguna unidad CD/DVD: añada una para arrancar desde imagen ISO.',
      mountGuestTools: 'Montar TVirt Guest Tools en el primer arranque',
      mountGuestToolsHint: 'Pone la ISO con los drivers virtio y el guest agent en una unidad CD vacía (añadida si hace falta) — el instalador de Windows la necesita para ver los discos.',
      noNicsHint: 'Ninguna interfaz de red: la VM arrancará sin conectividad.',
      taggedMappings: 'Mappings VLAN tagged',
      summaryDevices: 'Dispositivos',
      bootOrderTitle: 'Orden de boot',
      bootOrderHint: 'Arrastre para reordenar — gana el primer dispositivo arrancable; las NIC arrancan PXE',
      bootOrderUp: 'Subir',
      bootOrderDown: 'Bajar',
      createError: 'Creación fallida'
    },
    edit: {
      button: 'Editar',
      title: 'Editar máquina virtual',
      cancel: 'Cancelar',
      save: 'Guardar',
      error: 'Modificación fallida',
      modelStoppedOnly: 'Modificable solo con la VM apagada',
      firmwareStoppedOnly: 'Firmware modificable solo con la VM apagada — el próximo arranque usa el firmware nuevo y las variables UEFI se conservan',
      hugePagesStoppedOnly: 'Modificable solo con la VM apagada — en el próximo arranque la memoria nace con el nuevo respaldo',
      runningHint: 'Los cambios se aplican en el próximo power cycle',
      sectionCpu: 'CPU',
      sectionMemory: 'Memoria',
      sectionPolicy: 'Políticas'
    },
    devices: {
      networkChip: 'red fabric',
      title: 'Dispositivos',
      usb: 'USB',
      gpu: 'GPU',
      addUsb: 'Añadir dispositivo USB',
      addUsbTitle: 'Requerir una clase de dispositivos USB',
      usbClassHint: 'La VM pide una CLASE de dispositivos USB (un valor de un tag usb-device), nunca un dispositivo puntual: en el arranque se elige y se reserva el dispositivo libre concreto en el nodo. Asigne tags a los dispositivos registrados en Clúster › Recursos USB y PCIe.',
      usbTag: 'Tag (usb-device)',
      usbValue: 'Valor de la clase',
      noUsbTags: 'Ningún tag usb-device — cree uno y asigne tags a los dispositivos registrados en Clúster › Recursos USB y PCIe.',
      noUsbValues: 'Este tag aún no tiene valores declarados.',
      usbEmpty: 'Ningún requisito USB — añada una clase para pasar un dispositivo en el arranque.',
      usbClassChip: 'clase',
      usbPortChip: 'puerto',
      usbUnclaimed: 'Ningún dispositivo reservado — se resuelve en el arranque de la VM.',
      addGpu: 'Añadir GPU',
      addGpuTitle: 'Requerir una clase de GPU',
      gpuClassHint: 'La VM pide una CLASE de GPU (un valor de un tag gpu-device), nunca una tarjeta puntual: en el arranque la tarjeta libre concreta se elige y se reserva en el nodo, y pasa JUNTO todo su grupo IOMMU. Asigne tags a las GPU registradas en Clúster › Recursos USB y PCIe.',
      gpuTag: 'Tag (gpu-device)',
      gpuValue: 'Valor de la clase',
      noGpuTags: 'Ningún tag gpu-device — cree uno y asigne tags a las GPU registradas en Clúster › Recursos USB y PCIe.',
      noGpuValues: 'Este tag aún no tiene valores declarados.',
      gpuEmpty: 'Ningún requisito GPU — añada una clase para pasar una tarjeta en el arranque.',
      gpuClassChip: 'clase',
      gpuGroupChip: 'grupo IOMMU ×',
      gpuUnclaimed: 'Ninguna tarjeta reservada — se resuelve en el arranque de la VM.',
      gpuPowerCycle: 'Sin hotplug de GPU — los cambios valen desde el próximo power cycle (PendingRestart)',
      actions: 'Acciones',
      attachDisk: 'Añadir disco',
      attachDiskTitle: 'Añadir un disco',
      attach: 'Conectar',
      noFreeDisks: 'Ningún disco sin usar — cree uno en Máquinas virtuales › Discos sin usar.',
      addCdrom: 'Añadir unidad',
      addCdromTitle: 'Añadir una unidad CD/DVD',
      editCdromTitle: 'Cambiar imagen CD/DVD',
      changeMedia: 'Cambiar imagen CD/DVD',
      ejectMedium: 'Expulsar',
      mountGuestTools: 'Montar TVirt Guest Tools',
      guestToolsMounted: 'TVirt Guest Tools montadas',
      guestToolsClickMount: 'Pone la ISO TVirt Guest Tools en la primera unidad CD/DVD vacía',
      guestToolsClickUnmount: 'Haga clic para expulsar — la unidad se queda, vacía',
      guestToolsNoSlot: 'Ninguna unidad CD/DVD vacía — añada una unidad (o expulse un medio) para montar las TVirt Guest Tools',
      guestToolsSkew: 'Montada la v{pinned}; el nodo {node} ahora sirve la v{current}: expulsa y vuelve a montar para actualizar',
      ejectGuestTools: 'Expulsar TVirt Guest Tools (la unidad se queda, vacía)',
      guestToolsEjectConfirmTitle: '¿Expulsar las TVirt Guest Tools?',
      guestToolsEjectConfirmBody: 'El medio se expulsa de la VM encendida — la unidad CD/DVD se queda, vacía.',
      applyLive: 'Aplicar de inmediato (la VM está encendida)',
      addNic: 'Añadir interfaz',
      addNicTitle: 'Añadir una interfaz de red',
      editNicTitle: 'Editar interfaz de red',
      bridgeChip: 'bridge',
      cable: 'Cable virtual',
      plug: 'Conectar el cable virtual',
      unplug: 'Desconectar el cable virtual',
      remove: 'Quitar',
      removeTitle: '¿Quitar {device}?',
      removeBody: 'Con la VM encendida el cambio se aplica en el próximo power cycle. Discos e imágenes se desconectan, nunca se eliminan.'
    }
  }
}
